<template>
  <v-card>
    <v-card-title >
      <v-container>
      <div>
        <h5 class="text-xs-center title">
          Holdings
        </h5>
      </div>
      </v-container>
    </v-card-title>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="tmpItems"
          hide-actions
          class="elevation-1 columnHeading"
        >
          <template slot="items" slot-scope="props">
            <td
              :style="props.item.color">{{ props.item.category }}</td>
            <td>{{ props.item.ticker }}</td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.percent }}</td>
            <td class="text-xs-right">{{ props.item.percentChange }}</td>
            <td class="text-xs-right">
              {{ props.item.assetPercent }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Security from '@/classes/Security.class'
import ModelPosition from '@/classes/ModelPosition.class'

export default {
  props: ['id'],
  data () {
    return {
      headers: [
        { text: 'Category', align: 'left', sortable: true, value: 'category', width: '100px;' },
        { text: 'Symbol', align: 'left', sortable: true, value: 'ticker', width: '30px;' },
        { text: 'Security', align: 'left', sortable: true, value: 'name', width: '300px;' },
        { text: 'Percent', align: 'right', sortable: true, value: 'percent', width: '30px;' },
        { text: '% Change (%)', align: 'right', sortable: true, value: 'percentChange' },
        { text: '% Assets as of 2017-10-3 (%)', align: 'right', sortable: true, value: 'assetPercent', width: '30px;' }
      ],
      footer: [
        { value: false, ticker: '', name: 'Total', guidance: null, percentChange: null, assetPercent: 100.00 }
      ],
      colors: {
        'Cash': '#dfbfbf;',
        'Commodity': '#fac0be;',
        'Currency': '#ffd9bf;',
        'Intl Equity': '#fff0bf;',
        'Intl Income': '#f0ffc0;',
        'Intl REIT': '#deffdd;',
        'Quasi Income': '#beeaff;',
        'US Equity': '#bfd2ff;',
        'US Income': '#bfbffb;',
        'US REIT': '#b4b4d9;'
      }
    }
  },
  computed: {
    ...mapGetters({
      modelPositionsList: 'models/modelPositionsList',
      security: 'sec/security'
    }),

    portfolioResult () {
      return this.$store.getters.portResult(this.id, 'perf_summary')
    },
    tmpItems () {
      var newItems = []
      const positions = this.modelPositionsList
      for (var i = 0; i < positions.length; i++) {
        var position = new ModelPosition(positions[i])
        position.security = new Security(this.security(position.ticker))
        var newPosition = {
          value: false,
          ticker: position.ticker,
          name: position.security.name,
          category: position.security.category,
          percent: position.percent,
          percentChange: 0,
          assetPercent: position.percent,
          color: 'background-color: ' +
            this.colors[position.security.category.trim()] + ';'
        }
        newItems.push(newPosition)
      }
      return newItems
    }
    //   headers () {
    //     return this.portfolioResult.headers
    //   },
    //   items () {
    //     return this.portfolioResult.items
    //   }
  }
}
</script>

<style scoped>
  .columnHeading {
    font-size: 10px;
    font-style: bold;
  }
  .title {
    font-style: bold;
  }
  .thead {
    font-size: 10px;
  }
  td {
    width: 10px;

  }
</style>
